export const backendUrl = import.meta.env.VITE_BACKEND_URL
export const gtmId = import.meta.env.VITE_GTM_ID
export const isServer = typeof window === 'undefined'
export const mixpanelToken = import.meta.env.VITE_MIXPANEL_TOKEN